export default __webpack_public_path__ + "static/media/image.59867f7a.png";